module.exports = __webpack_public_path__ + "img/menuIcon20.93583937.png";